// extracted by mini-css-extract-plugin
export var bioContainer = "projectCard-module--bioContainer--OpdXa";
export var button = "projectCard-module--button--sRLUy";
export var buttonContainer = "projectCard-module--buttonContainer--eq1Yn";
export var cardContainer = "projectCard-module--cardContainer--DtGiB";
export var line = "projectCard-module--line--Tc4Yw";
export var title = "projectCard-module--title--uIm2J";